import _pacFunc from "../functions/profiles/ssPoliscript.js";
import _convertToPlainText from "../functions/quill/convertToPlainText.js";
import _fixEnglishTextInRTLLanguage from "../functions/quill/fixEnglishTextInRTLLanguage.js";
import _convertToHtml from "../functions/quill/convertToHtml.js";
import _getFormatOptions from "../functions/helpers/getFormatOptions.js";
import _tcLib from "../lib/timecode.js";
import _Event from "../classes/event.js";
const Event = _Event;
const tcLib = _tcLib;
const getFormatOptions = _getFormatOptions;
const convertToHtml = _convertToHtml;
const fixEnglishTextInRTLLanguage = _fixEnglishTextInRTLLanguage;
const convertToPlainText = _convertToPlainText;
const pacFunc = _pacFunc;
export default {
  decode: function (input, options) {
    let events = [],
      codePage = 28591,
      decodingOptions = getFormatOptions(options.formatOptions);
    if (decodingOptions["Code Page"]) {
      if (decodingOptions["Code Page"] === "auto") {
        // Use the analyze function to determine the code page
        let analysisResult = pacFunc.analyzePacFile(input);
        codePage = analysisResult.codePage;
        // console.log(`Auto-detected language: ${analysisResult.language || "Unknown"}, using code page: ${codePage}`);
      } else {
        codePage = pacFunc.codePageMapping[decodingOptions["Code Page"]] || 28591;
      }
    }
    let pacLine = {},
      pacLines = [];

    //file header is first 24 bytes (48 chars). Remove these from input:
    let inputBytes = input.match(/(..?)/g);
    let fileHeader = inputBytes.splice(0, 24).join();
    // console.log("File Header: ", fileHeader);

    while (inputBytes.length > 0) {
      if (inputBytes.join("").startsWith("ff000000000000000000000011")) {
        /* Footer */
        // console.log("REACHED THE FOOTER");
        // console.log(inputBytes.join(""));
        break;
      }
      let incodeHex = inputBytes.splice(0, 4);
      let outcodeHex = inputBytes.splice(0, 4);
      pacLine.incodeHex = incodeHex;
      pacLine.outcodeHex = outcodeHex;

      /* Timecode Debug */
      // console.log("Event: "+ pacLines.length+1);
      // console.log(incodeHex + "-->" + pacFunc.decodeTc(incodeHex));
      // console.log(outcodeHex + "-->" + pacFunc.decodeTc(outcodeHex));
      pacLine.incode = pacFunc.decodeTc(incodeHex);
      pacLine.outcode = pacFunc.decodeTc(outcodeHex);
      pacLine.start = tcLib.tcToSec(pacLine.incode, options.frameRate, options.dropFrame);
      pacLine.end = tcLib.tcToSec(pacLine.outcode, options.frameRate, options.dropFrame);
      let textLengthLow = inputBytes.splice(0, 1);
      let textLengthHigh = inputBytes.splice(0, 1);
      let textLength = textLengthHigh.concat(textLengthLow);
      let textLengthInt = parseInt(textLength.join(""), 16);
      // console.log(textLengthInt);

      /* We need to rewrite this statement to capture the correct number of control bytes since it is not always the same number. We're looking for everything up to the first "fe" and then two bytes past. e.g. '0a', 'fe', '02', '03'. <- Stop after '03' because it is the second control byte after "fe". */
      let feFlag = false,
        controlByteCountAfterFe = 0;
      pacLine.controlBytes = [];
      while (controlByteCountAfterFe < 2 && inputBytes.length > 0) {
        let controlByte = inputBytes.shift();

        //If the control byte is "00" and the previous 3 control bytes are all "80" (e.g. "80, 80, 80"). Then we need to exist the loop early and set the textLengthInt to 0.

        if (controlByte === "00") {
          let lastThreeControlBytes = pacLine.controlBytes.slice(-3);
          if (lastThreeControlBytes.length === 3 && lastThreeControlBytes.every(byte => byte === "80")) {
            // console.log("Found 00 control byte with three preceding 80 control bytes. Ending control byte loop early and setting textLengthInt to 0.");
            textLengthInt = 0;
            break;
          }
        }
        pacLine.controlBytes.push(controlByte);
        if (feFlag) {
          controlByteCountAfterFe++;
        }
        if (controlByte === "fe") {
          feFlag = true;
        }
      }
      /* Control Byte End */

      pacLine.vertical = parseInt(pacLine.controlBytes[0], 16) / 11; //Percentage of screen height
      pacLine.yPos = Math.round(pacLine.vertical * options.window.height);
      if (pacLine.vertical < 0.2) {
        pacLine.yPos = "start";
      }
      if (pacLine.vertical > 0.8) {
        pacLine.yPos = "end";
      }
      pacLine.alignment = pacFunc.alignmentMap[pacLine.controlBytes[5]] || "center";
      if (pacLine.alignment === "left") {
        pacLine.xPos = "start";
      } else if (pacLine.alignment === "right") {
        pacLine.xPos = "end";
      } else {
        pacLine.xPos = "center";
      }

      // console.log("Alignment byte: " + pacLine.controlBytes[5] + " -> " + pacLine.xPos);

      pacLine.textLength = textLengthInt;
      if (textLengthInt > 0) {
        pacLine.rawTextBytes = inputBytes.splice(0, textLengthInt - pacLine.controlBytes.length); //Subtract control bytes and the two bytes for text length
        pacLine.text = pacFunc.decodeRawTextBytes(pacLine.rawTextBytes, codePage);
        if (codePage === 28596 || codePage === 58598) {
          pacLine.text = fixEnglishTextInRTLLanguage(pacLine.text);
        }
        pacLine.html = convertToHtml(pacLine.text);
      }
      if (inputBytes.join("").startsWith("ff000000000000000000000011")) {
        /* Footer */
        pacLines.push(pacLine);
        break;
      }
      if (textLengthInt - pacLine.controlBytes.length > 0) {
        pacLine.footer = inputBytes.splice(0, 4);
      } else {
        // console.log("TEXT LENGTH IN IS SHORTER")
        let searching = true;
        pacLine.footer = "";
        while (searching && inputBytes.length > 0) {
          //Looking for next hex value of 60
          let searchRes = inputBytes.shift();
          pacLine.footer += searchRes;
          if (searchRes >= 60 && searchRes <= 65) {
            searching = false;
          }
        }
      }

      // console.log(pacLine);
      pacLines.push(pacLine);
      pacLine = {};
    }
    pacLines.forEach(pacLine => {
      events.push(new Event({
        start: pacLine.start,
        end: pacLine.end,
        text: pacLine.html,
        alignment: pacLine.alignment,
        xPos: pacLine.xPos,
        yPos: pacLine.yPos
      }));
    });
    if (decodingOptions["Ignore Metadata"]) {
      try {
        if (tcLib.secToTc(events[0].start, options.frameRate, options.dropFrame) === "00:00:00:00" && tcLib.secToTc(events[0].end, options.frameRate, options.dropFrame) === "00:00:00:08") {
          events.shift();
        }
      } catch (e) {
        console.log("Unable to detect metadata in PAC source");
      }
    }

    // console.log(JSON.stringify(events, null, 4));

    return events;
  },
  encode: function (eventGroup, options) {
    let output = "",
      codePage = 28591,
      format = "standard",
      pacHeaderOpt = "808080",
      encodingOptions = getFormatOptions(options.formatOptions);
    let unicode = options.profile === "ssPoliscriptUnicode";
    if (!unicode && encodingOptions["Code Page"]) {
      codePage = pacFunc.codePageMapping[encodingOptions["Code Page"]] || 28591;
    }
    if ((encodingOptions["Encode Story Event"] === true || encodingOptions["Encode Story Event"] === "true") && encodingOptions["Story Event Text"]) {
      let storyEvent = new Event({
        start: 0,
        end: 8 / options.frameRate,
        xPos: "start",
        alignment: "left",
        yPos: "start",
        text: convertToHtml(encodingOptions["Story Event Text"])
      });
      eventGroup.events.unshift(storyEvent);
    }
    output += pacFunc.encodeHeader();
    eventGroup.events.forEach((event, index, events) => {
      /* Timecode */
      output += pacFunc.encodeTc(event.start, options.frameRate, options.dropFrame);
      output += pacFunc.encodeTc(event.end, options.frameRate, options.dropFrame);
      let textHexCodes = pacFunc.encodeText(event, codePage, unicode);
      output += pacFunc.encodeTextLength(textHexCodes, format, pacHeaderOpt);
      output += "00";
      output += pacFunc.encodeYPos(event, options.window);
      output += pacHeaderOpt;
      output += "fe";
      output += pacFunc.encodeAlignment(event);
      output += "03";
      output += textHexCodes;
      if (index < events.length - 1) {
        output += "00";
        output += parseInt((index + 2) % 256).toString(16).padStart(2, "0");
        output += parseInt((index + 2) / 256).toString(16).padStart(2, "0");
        output += "60";
      }
    });
    output += pacFunc.encodeFooter();
    return output;
  },
  preProcess: {
    encode: function (eventGroup) {
      return eventGroup;
    },
    decode: function (input) {
      return input.toLowerCase();
    }
  },
  postProcess: {
    encode: function (output) {
      return output;
    },
    decode: function (eventGroup) {
      eventGroup.events = eventGroup.events.filter(event => {
        event.text = event.text.replace(/åo/g, "ö").replace(/åO/g, "Ö").replace(/äo/g, "ô").replace(/sº/g, "soe").replace(/ÿ+/gmi, "").replace("dummy end of file", "");
        //console.log(event.text);
        //replace one or more  and null codes with empty string
        event.text = event.text.replace(/(|\x00||||)+/g, "").replace(/[\x00-\x1F\x7F]/g, '').replace("ymmud dne fo elif", "dummy end of file");
        let plainText = convertToPlainText(event.text).toLowerCase();
        return plainText != "dummy end of file" && event.start != "" && event.end != "" && plainText != "";
      });
      return eventGroup;
    }
  }
};